<template>
  <div class="aim-list-container" v-loading="uploadLoading" element-loading-text="文件上传中...">
    <div class="choose-options">
      <el-select v-model="searchInfo.cate_code" placeholder="请选择意图类别" clearable>
        <el-option v-for="item in aimTypes" :key="item.id" :label="item.cate_name" :value="item.cate_code">
        </el-option>
      </el-select>
      <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
        <el-option v-for="item in robotTypes" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="searchInfo.order" placeholder="请选择排序方式" clearable>
        <el-option v-for="item in orderOption" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="searchInfo.is_replied" placeholder="请选择回复状态" clearable>
        <el-option v-for="item in replyOption" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="searchInfo.keyword" placeholder="请输入意图名称" clearable />
      <el-button type="three" @click="getLists({ type: 'search' })">筛选</el-button>
      <el-button type="three" @click="resetSearchInfo">重置</el-button>
    </div>
    <div class="btn-container">
      <el-button type="three" size="medium" @click="addAim('add')">添加意图</el-button>
      <!-- <el-upload
        class="upload-demo"
        action="/admin/intent/lead"
        :headers="headers"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button type="three">一键导入</el-button>
      </el-upload>
      <el-button type="three" size="medium" @click="getLists({ e: 1 })"
        >一键导出</el-button
      > -->
    </div>
    <div class="slot-lists">
      <div v-for="(item, index) in aimLists" :key="item.intent_code"
        :class="`slot-container ${item.is_replied == 1 ? '' : 'not-replied'}`">
        <div class="header">
          <div class="lf">
            <el-tooltip placement="bottom" width="200" trigger="hover" :content="item.intent_name">
              <div class="intent-name">{{ item.intent_name }}</div>
            </el-tooltip>
          </div>
          <div class="rt">{{ item.intent_code }}</div>
        </div>
        <div class="content">
          <div class="lf">
            <el-dropdown trigger="click" @command="(e) => togleAim(e, item)">
              <div>
                {{ getAimText(item)
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown" class="my-dropdown">
                <el-dropdown-item v-for="(item1, index1) in aimTypes" :key="index1" :command="index1">{{ item1.cate_name
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div @click="addAim('question', item)" class="question">
              扩充问法：{{ item.standard }}
            </div>
            <div class="anscode">{{ item.ans_code }}</div>
          </div>
          <div class="rt">
            <el-tooltip class="item" content="导入回复" placement="bottom">
              <el-upload ref="uploadRef" class="upload-demo" :show-file-list="false" action="admin/answer/importReply"
                :http-request="(options) => handleReplyUpload(options, item)">
                <template #trigger>
                  <img src="@/assets/images/importImg.png" class="operation-upload" />
                </template>

              </el-upload>

            </el-tooltip>
            <el-tooltip class="item" content="关联槽值" placement="bottom">

              <img src="@/assets/images/relative.png" class="operation-icon" @click="addAim('relative', item)" />
            </el-tooltip>
            <el-tooltip content="快捷" placement="bottom" width="200" trigger="hover">
              <img src="@/assets/images/quick.png" class="operation-icon" @click="addAim('quick', item)" />
            </el-tooltip>
            <el-dropdown trigger="click" @command="(e) => {
              togleEdit(e, item)
            }
              ">
              <el-tooltip content="编辑" placement="bottom" width="200" trigger="hover">
                <img src="@/assets/images/edit.png" class="operation-icon" />
              </el-tooltip>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item1, index1) in item.editType" :key="index1" :command="index1">{{ item1.label
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown trigger="click" @command="(e) => {
              onTogle(e, item, index)
            }
              ">
              <el-tooltip :content="item.status == 1 ? '隐藏' : '显示'" placement="bottom" width="200" trigger="hover">
                <img v-if="item.status == 1" src="@/assets/images/hide.png" class="operation-icon last-child" />
                <img v-else src="@/assets/images/show.png" class="operation-icon last-child" />
              </el-tooltip>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item1, index1) in robotTypes" :key="index1" :command="item1.value"
                  :disabled="item1.value == item.status">{{ item1.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <el-empty :image-size="200" v-if="aimLists.length <= 0"></el-empty>
    </div>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="12"
      layout="total, prev, pager, next, jumper" :total="total" prev-text="上一页" next-text="下一页" v-if="total > 12">
    </el-pagination>
    <div v-if="dialogVisible">
      <el-dialog :close-on-click-modal="false" :title="titleText" :visible.sync="dialogVisible"
        :before-close="closeDialog" width="880px" v-loading="loading" element-loading-text="数据提交中...">
        <aim-value labelName="扩充问法" v-if="dialogType == 'question'" :dataList="dataList" :searchInfo="slotSearch"
          @my-search="onSearch" @my-add="onAdd" @my-delete="onDelete" @my-input="onInput"
          @onSearchChange="onSearchChange"></aim-value>
        <!-- <my-relative v-else-if="dialogType == 'relative'"></my-relative> -->
        <my-reslot v-else-if="dialogType == 'relative'"></my-reslot>
        <my-quick v-else-if="dialogType == 'quick'" :keyword="keyword" @quickChange="quickChange"></my-quick>
        <my-add v-else-if="dialogType == 'add'" :addForm="addForm" :aimTypes="aimTypes"></my-add>
        <my-question v-if="dialogType == 'tellQ' || dialogType == 'wordQ'"></my-question>

        <my-reply v-if="dialogType == 'tellR' || dialogType == 'wordR'" :status="replyForm.status"></my-reply>
        <my-slot v-if="dialogType == 'tellM' || dialogType == 'wordM'"></my-slot>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" round @click="closeDialog">取消</el-button>
          <el-button size="medium" round type="primary" @click="confirm">提交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { isSuccess, isEmpty, getCompletionUrl } from '@/utils/index'
import { ROBOT_STATUS, ROBOT_TYPES, ROBOT_TEXT } from '@/utils/const'
import {
  getIntentList,
  getCombineList,
  getCorrelation,
  changeIntentStatus,
  changeAim,
  getExtendList,
  deleteExtend,
  addIntent,
  addQuick,
  addExtend,
  addRelative,
  getReplyList,
  getSlotLists,
  getAnmalyDetail,
  getStandard,
  editStandard,
  editAnomaly,
  editReply,
  getClassList,
  addRelativeSlot,
  uploadReply
} from '@/api/aimManager'
export default {
  components: {
    'aim-value': () => import('@/components/aimInfo/index.vue'),
    'my-relative': () => import('@/components/aimInfo/relative.vue'),
    'my-quick': () => import('@/components/aimInfo/quick.vue'),
    'my-add': () => import('@/components/aimInfo/addAim.vue'),
    'my-edit': () => import('@/components/aimInfo/editAim.vue'),
    'my-question': () => import('@/components/aimInfo/questionManager.vue'),
    'my-slot': () => import('@/components/aimInfo/slotManager.vue'),
    'my-reply': () => import('@/components/aimInfo/replyManager.vue'),
    'my-reslot': () => import('@/components/aimInfo/relativeSlot.vue'),
  },
  data() {
    return {
      robotTypes: ROBOT_TYPES,
      orderOption: [
        {
          label: '添加时间',
          value: 'save_time',
        },
        {
          label: '热度',
          value: 'count',
        },
      ],
      value: '',
      inputContent: '',
      titleText: '添加',
      isOpened: false,
      dialogVisible: false,
      dialogType: 'add',
      currentPage: 1,
      total: 0,
      aimLists: [], //意图列表
      currentItem: {}, //当前操作的对象
      addForm: {
        //增加意图
        intent_name: '',
        cate_code: '',
        keyword: '',
        slot_list: [],
      },
      aimTypes: [], //意图类别列表
      dataList: [], // 当前槽值列表
      slotSearch: '', // 槽值搜索
      searchInfo: {
        cate_code: '',
        status: ROBOT_STATUS.show,
        keyword: '',
        order: '',
        is_replied: '',
      },
      editType: 2,

      replyForm: {
        // 回复管理
      },
      keyword: '', //快捷短语
      fileList: [], // 一键导入列表
      headers: {
        token: window.sessionStorage.getItem('token'),
      },
      replyOption: [
        {
          label: '已回复',
          value: 1,
        },
        {
          label: '未回复',
          value: 2,
        },
      ],
      slot_list: [],
      loading: false,
      uploadLoading: false
    }
  },
  mounted() {
    this.getLists({})
    this.getAimType()
    this.gettSlotList()
  },
  computed: {
    ...mapState({
      combine: (state) => state.aimManager.combine,
      replyList: (state) => state.aimManager.replyList,
      questionForm: (state) => state.aimManager.questionForm,
      slotForm: (state) => state.aimManager.slotForm,
      transfer: (state) => state.aimManager.transfer,
      slotList: (state) => state.aimManager.slotList,
      combineSlot: (state) => state.aimManager.combineSlot,
    }),
    getStatusText: function () {
      return (status) => {
        return status == ROBOT_STATUS.hidenStatus
          ? ROBOT_TEXT.hide
          : ROBOT_TEXT.show
      }
    },
    getAimText() {
      return (item) => {
        let index = this.aimTypes.findIndex(
          (value) => value.cate_code == item.cate_code
        )
        return index > -1 ? this.aimTypes[index].cate_name : ''
      }
    },
  },
  methods: {
    ...mapMutations('aimManager', [
      'setAimList',
      'setCombine',
      'setReplyList',
      'setSlotList',
      'setQuestionForm',
      'setSlotForm',
      'setCombineSlot',
    ]),
    async getLists({ type, e = 0 }) {
      if (type == 'search') {
        this.currentPage = 1
      }
      const res = await getIntentList({
        page: this.currentPage,
        ...this.searchInfo,
        status: isEmpty(this.searchInfo.status)
          ? ROBOT_STATUS.show
          : this.searchInfo.status,
        pagesize: 12,
        export: e,
      })
      if (e && res.code != -1) {
        window.location.href = getCompletionUrl(res.data)

        return
      }
      this.aimLists = res.data.list
      this.aimLists = this.aimLists.map((item) => {
        item.editType = [
          {
            label: '问法管理',
            title: '问法管理',
            value: 'tellQ',
          },
          {
            label: '回复管理',
            title: '回复管理',
            value: 'tellR',
          },
          {
            label: '异常管理',
            title: '异常管理',
            value: 'tellM',
          },
        ]
        return item
      })
      this.total = res.data.total
    },
    async getAimType() {
      const res = await getClassList({ is_all: 1 })
      this.aimTypes = res.data.list
      // this.$store.commit('aimManager/setAimList', this.aimTypes)
    },
    async gettSlotList() {
      const res = await getSlotLists()
      this.setSlotList(res.data.list)
    },
    async addAim(type, item) {
      if (typeof item == 'object') {
        this.currentItem = item
      }
      switch (type) {
        case 'add': {
          this.titleText = '添加意图'
          break
        }
        case 'edit': {
          this.titleText = '修改'
          break
        }
        case 'relative': {
          // this.titleText = '关联意图'
          // const res = await Promise.all([
          //   getCombineList({
          //     intent_code: item.intent_code,
          //   }),
          //   getCorrelation({ intent_code: item.intent_code }),
          // ])
          // this.setCombine(res[0].data.combine_list)
          // this.setAimList(res[1].data)
          this.titleText = '关联槽值'
          this.slot_list = item.slot_list
          this.setCombineSlot(item.slot_list ? item.slot_list : [])
          break
        }
        case 'question': {
          this.titleText = '扩充问法'
          await this.getSlotvallist({
            intent_code: item.intent_code,
          })
          this.currentItem = item

          this.slotVisible = true
          break
        }
        case 'quick': {
          this.titleText = '快捷短语'
          this.keyword = item.keyword
          break
        }
      }
      this.dialogType = type
      this.dialogVisible = true
    },
    closeDialog() {
      switch (this.dialogType) {
        case 'add': {
          this.addForm = {
            intent_name: '',
            cate_code: '',
            keyword: '',
            slot_list: [],
          }
          break
        }
        case 'question': {
          this.slotSearch = ''
          break
        }
        case 'tellR':
        case 'wordR': {
          this.setReplyList([])
          break
        }
        case 'relative': {
          this.transfer.$refs.leftPanel.checked = []
          this.transfer.$refs.rightPanel.checked = []
          break
        }
      }
      this.getLists({})

      this.dialogVisible = false
    },
    /**
     * 翻页
     */
    handleCurrentChange() {
      this.getLists({})
    },
    /**
     * 当切换隐藏/显示时
     */
    async onTogle(e, item, index) {
      const res = await changeIntentStatus({
        id: item.id,
        status: e,
      })
      if (isSuccess(res.code)) {
        this.$message({
          type: 'success',
          message: '切换成功',
        })
        await this.getLists({})
        return
      }
    },
    /*
    切换意图
    */
    async togleAim(e, item) {
      const res = await changeAim({
        id: item.id,
        cate_code: this.aimTypes[e].cate_code,
      })
      if (isSuccess(res.code)) {
        this.$message({ type: 'success', message: '切换成功' })
        this.getLists({})
        return
      }
    },
    async getSlotvallist(params) {
      const res = await getExtendList(params)
      this.dataList = res.data.list
      if (this.dataList.length == 0) {
        this.dataList.push({ question: '', id: 0 })
      }
    },
    onSearchChange(e) {
      this.slotSearch = e
    },
    onSearch(value) {
      this.slotSearch = value
      this.getSlotvallist({
        intent_code: this.currentItem.intent_code,
        question: value,
      })
    },
    onAdd() {
      this.dataList.push({ question: '', id: 0 })
    },
    async onDelete(index) {
      if (this.dataList[index].id != 0) {
        const res = await deleteExtend({
          id: this.dataList[index].id,
        })
      }
      this.dataList.splice(index, 1)
      this.$message({ type: 'success', message: '删除成功' })
    },
    onInput(e, index) {
      this.dataList[index].question = e
    },
    /**
     * 确定
     */
    async confirm() {
      switch (this.dialogType) {
        case 'add': {
          this.addAimItem()
          break
        }
        case 'relative': {
          this.addRelative()
          break
        }
        case 'question': {
          this.addQuestion()
          break
        }
        case 'quick': {
          this.addQuick()
          break
        }
        case 'tellQ': {
          this.editQuestion()
          break
        }
        case 'tellM': {
          this.editSlot()
          break
        }
        case 'tellR': {
          this.editReply()
          break
        }
      }
    },
    async addAimItem() {
      const res = await addIntent(this.addForm)
      if (isSuccess(res.code)) {
        this.$message({
          type: 'success',
          message: res.message,
        })
        this.getLists({})
        this.closeDialog()
        return
      }
    },
    async addQuick() {
      const res = await addQuick({
        id: this.currentItem.id,
        keyword: this.keyword,
      })
      if (isSuccess(res.code)) {
        this.dialogVisible = false
        this.getLists({})
        this.$message({
          type: 'success',
          message: res.message,
        })
        return
      }
    },
    /**
     * 当修改快捷短语时
     */
    quickChange(e) {
      this.keyword = e
    },
    async addQuestion() {
      if (this.dataList.some((item) => isEmpty(item.question))) {
        this.$message.error('问法不能为空')
        return
      }
      this.dataList = this.dataList.map((item) => {
        return { id: item.id, question: item.question }
      })
      const res = await addExtend({
        intent_code: this.currentItem.intent_code,
        question: this.dataList,
      })
      if (isSuccess(res.code)) {
        this.$message({ type: 'success', message: res.message })
        this.closeDialog()
        this.getLists({})
        return
      }
    },
    async addRelative() {
      // if (!isEmpty(this.slot_list)) {
      //   this.$message.error('已经关联过槽值，不允许再修改')
      //   return
      // }
      if (isEmpty(this.combineSlot)) {
        this.$message.error('请关联槽值')
        return
      }
      await addRelativeSlot({
        id: this.currentItem.id,
        slot_list: this.combineSlot,
      })
      this.$message({ type: 'success', message: '关联成功' })
      this.getLists({})
      this.closeDialog()
    },
    /**
     * 切换编辑的弹窗
     */
    async togleEdit(e, item) {
      this.currentItem = item
      this.titleText = item.editType[e].title
      this.dialogType = item.editType[e].value
      this.dialogVisible = true
      switch (this.dialogType) {
        case 'tellR': {
          this.replyForm = {
            intent_code: item.intent_code,
          }
          const res = await getReplyList({ intent_code: item.intent_code })

          if (res.data.list.length == 0) {
            let item1 = {
              action: 1,
              interrupt: 1,
              is_default: 1,
              ans_text: '',
              slot1: '',
              slot1_val: '',
              slot2: '',
              slot2_val: '',
              slot3: '',
              slot3_val: '',
              audio: '',
              link_note: '',
              link: '',
              title: '',
              richtext: '',
              img: '',
              jump_link: '',
            }
            res.data.list.push(item1)
          }
          res.data.list = res.data.list.map((item, index) => {
            item.slotVal1 = [item.slot1, parseInt(item.slot1_val)]
            item.slotVal2 = [item.slot2, parseInt(item.slot2_val)]
            item.slotVal3 = [item.slot3, parseInt(item.slot3_val)]

            item.slotList = this.slotList
            item.label = '回复话术' + (index + 1)
            item.name = String(index)
            item.audio =
              item.audio && item.audio.audio ? item.audio.audio : ''
            return item
          })
          this.setReplyList(res.data.list)

          break
        }
        case 'tellM': {
          const res = await getAnmalyDetail({
            intent_code: item.intent_code,
          })
          let empty = res.data == null
          this.setSlotForm({
            btm_norec: empty ? '' : res.data.btm_norec,
            btm_nores: empty ? '' : res.data.btm_nores,
            retry_times: empty ? 1 : res.data.retry_times,
            err_action: empty ? 1 : res.data.err_action,
            err_code: empty ? '' : res.data.err_code,
            intent_code: item.intent_code,
          })
          break
        }
        case 'tellQ': {
          const res = await getStandard({
            intent_code: item.intent_code,
          })
          let empty = res.data == null
          this.setQuestionForm({
            intent_code: item.intent_code,
            intent_name: empty ? '' : res.data.intent_name,
            question: empty ? '' : res.data.question,
          })
          break
        }
      }
    },
    async editQuestion() {
      const res = await editStandard({
        ...this.questionForm,
      })
      if (isSuccess(res.code)) {
        this.setQuestionForm({
          intent_name: '',
          question: '',
        })
        this.$message.success(res.message)
        this.dialogVisible = false
        this.getLists({})
        return
      }
    },
    async editSlot() {
      const res = await editAnomaly({
        ...this.slotForm,
      })
      if (isSuccess(res.code)) {
        this.setSlotForm({
          btm_norec: '',
          btm_nores: '',
          retry_times: 1,
          err_action: 1,
          err_code: '',
        })
        this.$message.success(res.message)
        this.dialogVisible = false
        this.getLists({})
        return
      }
    },
    async editReply() {
      let formList = []
      // let notCorrect = this.replyList.some((item) => isEmpty(item.ans_text))
      // if (notCorrect) {
      //   this.$message.error('回复话术不能为空')
      //   return
      // }
      formList = this.replyList.map((item) => {
        if (!item.id) {
          item.id = 0
        }
        return {
          action: item.action,
          ans_text: item.ans_text,
          interrupt: item.interrupt,
          is_default: item.is_default,
          slot1: item.slot1,
          slot1_val: item.slot1_val,
          slot2: item.slot2,
          slot2_val: item.slot2_val,
          slot3: item.slot3,
          slot3_val: item.slot3_val,
          id: item.id,
          status: this.replyForm.status,
          link: item.link,
          link_note: item.link_note,
          ans_type: item.ans_type,
          audio: item.audio,
          title: item.title,
          richtext:
            item.richtext == '<p data-we-empty-p=""><br></p>'
              ? ''
              : item.richtext,
          img: item.img,
          jump_link: item.jump_link,
        }
      })
      this.loading = true
      try {
        const res = await editReply({
          intent_code: this.replyForm.intent_code,
          reply: formList,
        })
        this.loading = false
        if (isSuccess(res.code)) {
          this.$message.success(res.message)
          this.dialogVisible = false
          return
        }
      } catch (e) {
        this.loading = false
      }


    },
    chooseSlot(list) {
      this.replyList = list
    },
    beforeUpload(file) {
      let isCorrect = ['xlsx', 'xls'].some((item) => {
        return new RegExp(item).test(file.name)
      })
      if (!isCorrect) {
        this.$message.error('文件只能为xlsx, xls格式')
      }
      return isCorrect
    },
    handleSuccess(res) {
      if (isSuccess(res.code)) {
        this.$message.success('导入成功')
      } else {
        this.$message.error(res.message)
      }
    },
    resetSearchInfo() {
      this.searchInfo = {
        cate_code: '',
        status: ROBOT_STATUS.show,
        keyword: '',
        order: '',
        is_replied: '',
      }
      this.getLists('search')
    },
    async handleReplyUpload(options, item) {
      this.uploadLoading = true
      try {
        let formData = new FormData()
        formData.append('intent_code', item.intent_code)
        formData.append('file', options.file)
        const res = await uploadReply(formData)
        if (res?.code === 1) {
          this.$message.success('上传成功')
        }
        this.uploadLoading = false
      } catch (e) {
        this.uploadLoading = false
      }
    }
  },
}
</script>

<style lang="scss">
.aim-list-container {
  .slot-lists {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px 20px;
  }

  .slot-container {
    padding: 0 26px 17px 26px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-width: 410px;
    height: 170px;
    background: #ffffff;
    border: 1px solid #f5f5f5;
    box-shadow: 1px 4px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    box-sizing: border-box;
    color: #333;

    .header,
    .content {
      display: flex;
      justify-content: space-between;

      .el-button--primary {
        margin: 0;
        margin-right: 6px;
      }
    }

    .header {
      height: 54px;
      line-height: 54px;
      border-bottom: 1px solid #cccccc;

      .lf {
        display: block;
        font-size: 20px;
        display: flex;
        align-items: center;
        font-weight: 700;

        .relative {
          margin-right: 4px;
        }

        .intent-name {
          width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .rt {
        font-size: 18px;
      }
    }

    .content {
      font-size: 16px;
      color: #606266;

      .el-dropdown-selfdefine {
        font-size: 16px;
      }

      .lf {
        cursor: pointer;
      }

      .rt {
        display: flex;
        align-items: flex-end;

        .operation-icon {
          margin-right: 24px;
        }

        .last-child {
          margin-right: 0;
        }
      }
    }

    .question {
      margin: 10px 0;
      text-decoration: underline;
    }

  }

  @media screen and (max-width: 1170px) {
    .slot-lists {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (min-width: 1170px) {
    .slot-lists {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (min-width: 1600px) {
    .slot-lists {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .not-replied {
    color: #999;

    .content,
    .el-dropdown {
      color: #999;
    }
  }

  .el-empty {
    margin: 0 auto;
  }

  .icon-lianjie:before {
    font-size: 18px;
    font-weight: 700;
    color: #e9c329;
    margin: 0 10px;
    cursor: pointer;
  }
}

.my-dropdown {
  height: 200px;
  overflow-y: scroll;
}

.my-dropdown::-webkit-scrollbar {
  width: 0;
}

.btn-container {
  display: flex;

  .el-button--three {
    margin-right: 10px;
  }
}

.item {
  margin-right: 24px;

  .el-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #f3fafe;

    .operation-upload {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
